export default {
      id: "ic_rank_badge_third-usage",
      viewBox: "0 0 19 19",
      url: "/" + "images/icons.3.109.2.svg#ic_rank_badge_third-usage",
      toString: function () {
        return this.url;
      }
    }